import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_BASE_URL}/api/`,
  prepareHeaders: (headers) => {
    headers.set('Accept', 'application/json');
    const token = localStorage.getItem('token');
    if (token) {
      headers.set('Authorization', `Token ${token}`);
    }
    return headers;
  },
});

export type BaseQueryType = typeof baseQuery;

const baseQueryWithInterceptor: BaseQueryType = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error) {
    const { status } = result.error;
    switch (true) {
      case status === 401:
        localStorage.removeItem('token');
        window.location.replace('/');
        break;
    }
  }
  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithInterceptor,
  endpoints: () => ({}),
});
